import { ButtonView, Editor, Plugin } from 'ckeditor5'

import { CommandName } from '../../types'
import { PlusIcon } from '../icons/PlusIcon'

export default class ImportNotesTemplateUI extends Plugin {
  init() {
    const editor = this.editor as Editor

    // Can import translation the following example
    // const NotesTemplate = enUSPbtCKEditor.Common.NOTES_TEMPLATE as unknown as string
    // addTranslation('es', {
    //   [NotesTemplate]: esESPbtCKEditor.Common.NOTES_TEMPLATE,
    // })

    editor.ui.componentFactory.add('importNotesTemplate', (locale) => {
      const command = editor.commands.get(
        CommandName.INSERT_IMPORT_NOTES_TEMPLATE,
      )
      const buttonView = new ButtonView(locale)

      buttonView.set({
        icon: PlusIcon,
        label: editor.t('Notes template'),
        tooltip: true,
        class: 'notes-template',
      })

      if (command) {
        // @ts-ignore
        buttonView.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled')
      }

      this.listenTo(buttonView, 'execute', () =>
        editor.execute(CommandName.INSERT_IMPORT_NOTES_TEMPLATE),
      )

      return buttonView
    })
  }
}
